module.exports = __webpack_public_path__ + "img/SIM.4ed3f4fd.svg";